/* eslint-disable react/jsx-no-useless-fragment */
import { Box } from '@mui/material';
import { BASEURL } from 'context/context';
import React, { useEffect, useState } from 'react';
import './DiscountCode.css';

export type IDiscountCodeProps = {

}

const DiscountCode: React.FC<IDiscountCodeProps> = ({ }) => {
  const [discountCode, setDiscountCode] = useState('');

  const getUserCode = async () => {
    const userId = localStorage.getItem('userId');

    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');

    const raw = JSON.stringify({
      userId,
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };
    try {
      const result = await fetch(`${BASEURL}/getUserDiscount`, requestOptions as any);
      const userCode = await result.text();

      setDiscountCode(userCode);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    getUserCode();
  }, []);

  if (discountCode === '') {
    return (
      <></>
    );
  }

  return (
    <Box sx={{ position: 'relative', boxSizing: 'border-box' }}>
      <Box
        sx={{
          position: 'absolute',
          bottom: '120px',
          right: '-80px',
          transform: 'rotate(-42deg)',
          backgroundColor: '#FEC260',
          display: 'flex',
          width: '450px',
          marginBottom: '10px',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          padding: '5px',
          color: 'white',
        }}
        className="discountCode"
      >
        <Box>
          Discount Code
        </Box>
        <Box>
          {discountCode}
        </Box>
      </Box>
    </Box>
  );
};

export { DiscountCode };
